import { useRef, useEffect } from "react";

/**
 * This is a hook to check if the current Component is mounted,
 * such that we only perform things like state updated when the
 * component is mounted
 */

type IsMounted = {
    current: boolean;
};

const useIsMounted = (): IsMounted => {
    const isMountedRef = useRef(null);
    useEffect(() => {
        isMountedRef.current = true;
        return () => (isMountedRef.current = false);
    });
    return isMountedRef;
};

export default useIsMounted;
